module.exports = __webpack_public_path__ + "media/images/logo-aef5e832a2a81a35d6c6b108ab7cfc69.svg";